/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AdminRouteImport } from "./routes/admin"
import { Route as userRouteRouteImport } from "./routes/(user)/route"
import { Route as publicRouteRouteImport } from "./routes/(public)/route"
import { Route as publicIndexRouteImport } from "./routes/(public)/index"
import { Route as userTmpRouteImport } from "./routes/(user)/tmp"
import { Route as userOnboardingRouteImport } from "./routes/(user)/onboarding"
import { Route as userAccountRouteImport } from "./routes/(user)/account"
import { Route as publicPricingRouteImport } from "./routes/(public)/pricing"
import { Route as usertenantBcRouteRouteImport } from "./routes/(user)/(tenantBc)/route"
import { Route as publicAuthRouteRouteImport } from "./routes/(public)/auth/route"
import { Route as publicAuthIndexRouteImport } from "./routes/(public)/auth/index"
import { Route as usertenantBcSettingsRouteImport } from "./routes/(user)/(tenantBc)/settings"
import { Route as usertenantBcPurchaseRouteImport } from "./routes/(user)/(tenantBc)/purchase"
import { Route as usertenantBcDashboardRouteImport } from "./routes/(user)/(tenantBc)/dashboard"
import { Route as publicLegalSlugRouteImport } from "./routes/(public)/legal.$slug"
import { Route as publicContentSlugRouteImport } from "./routes/(public)/content.$slug"
import { Route as publicAuthOauthResultRouteImport } from "./routes/(public)/auth/oauth-result"
import { Route as publicAuthLoginRouteImport } from "./routes/(public)/auth/login"
import { Route as userTTenantSlugRouteRouteImport } from "./routes/(user)/t.$tenantSlug/route"
import { Route as usertenantBcWorkflowsIndexRouteImport } from "./routes/(user)/(tenantBc)/workflows/index"
import { Route as usertenantBcPromptsIndexRouteImport } from "./routes/(user)/(tenantBc)/prompts/index"
import { Route as usertenantBcEvaluationsIndexRouteImport } from "./routes/(user)/(tenantBc)/evaluations/index"
import { Route as usertenantBcDatasetsIndexRouteImport } from "./routes/(user)/(tenantBc)/datasets/index"
import { Route as publicAuthResetPasswordIndexRouteImport } from "./routes/(public)/auth/reset-password/index"
import { Route as userTTenantSlugSubscriptionRouteImport } from "./routes/(user)/t.$tenantSlug/subscription"
import { Route as userTTenantSlugSettingsRouteImport } from "./routes/(user)/t.$tenantSlug/settings"
import { Route as userTTenantSlugPurchaseRouteImport } from "./routes/(user)/t.$tenantSlug/purchase"
import { Route as userTTenantSlugDashboardRouteImport } from "./routes/(user)/t.$tenantSlug/dashboard"
import { Route as userTTenantSlugCheckoutRouteImport } from "./routes/(user)/t.$tenantSlug/checkout"
import { Route as usertenantBcWorkflowsIdRouteImport } from "./routes/(user)/(tenantBc)/workflows/$id"
import { Route as usertenantBcPromptsIdRouteImport } from "./routes/(user)/(tenantBc)/prompts/$id"
import { Route as usertenantBcEvaluationsIdRouteImport } from "./routes/(user)/(tenantBc)/evaluations/$id"
import { Route as usertenantBcDatasetsIdRouteImport } from "./routes/(user)/(tenantBc)/datasets/$id"
import { Route as publicAuthVerifyRequestRouteImport } from "./routes/(public)/auth/verify/request"
import { Route as publicAuthVerifyApplyRouteImport } from "./routes/(public)/auth/verify/apply"
import { Route as publicAuthResetPasswordTokenRouteImport } from "./routes/(public)/auth/reset-password/$token"
import { Route as userTTenantSlugWorkflowsIdRouteImport } from "./routes/(user)/t.$tenantSlug/workflows.$id"
import { Route as userTTenantSlugPromptsIdRouteImport } from "./routes/(user)/t.$tenantSlug/prompts.$id"
import { Route as userTTenantSlugEvaluationsIdRouteImport } from "./routes/(user)/t.$tenantSlug/evaluations.$id"
import { Route as userTTenantSlugDatasetsIdRouteImport } from "./routes/(user)/t.$tenantSlug/datasets.$id"

const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const userRouteRoute = userRouteRouteImport.update({
  id: "/(user)",
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: "/(public)",
  getParentRoute: () => rootRouteImport,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => publicRouteRoute,
} as any)
const userTmpRoute = userTmpRouteImport.update({
  id: "/tmp",
  path: "/tmp",
  getParentRoute: () => userRouteRoute,
} as any)
const userOnboardingRoute = userOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => userRouteRoute,
} as any)
const userAccountRoute = userAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => userRouteRoute,
} as any)
const publicPricingRoute = publicPricingRouteImport.update({
  id: "/pricing",
  path: "/pricing",
  getParentRoute: () => publicRouteRoute,
} as any)
const usertenantBcRouteRoute = usertenantBcRouteRouteImport.update({
  id: "/(tenantBc)",
  getParentRoute: () => userRouteRoute,
} as any)
const publicAuthRouteRoute = publicAuthRouteRouteImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => publicRouteRoute,
} as any)
const publicAuthIndexRoute = publicAuthIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => publicAuthRouteRoute,
} as any)
const usertenantBcSettingsRoute = usertenantBcSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => usertenantBcRouteRoute,
} as any)
const usertenantBcPurchaseRoute = usertenantBcPurchaseRouteImport.update({
  id: "/purchase",
  path: "/purchase",
  getParentRoute: () => usertenantBcRouteRoute,
} as any)
const usertenantBcDashboardRoute = usertenantBcDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => usertenantBcRouteRoute,
} as any)
const publicLegalSlugRoute = publicLegalSlugRouteImport.update({
  id: "/legal/$slug",
  path: "/legal/$slug",
  getParentRoute: () => publicRouteRoute,
} as any)
const publicContentSlugRoute = publicContentSlugRouteImport.update({
  id: "/content/$slug",
  path: "/content/$slug",
  getParentRoute: () => publicRouteRoute,
} as any)
const publicAuthOauthResultRoute = publicAuthOauthResultRouteImport.update({
  id: "/oauth-result",
  path: "/oauth-result",
  getParentRoute: () => publicAuthRouteRoute,
} as any)
const publicAuthLoginRoute = publicAuthLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => publicAuthRouteRoute,
} as any)
const userTTenantSlugRouteRoute = userTTenantSlugRouteRouteImport.update({
  id: "/t/$tenantSlug",
  path: "/t/$tenantSlug",
  getParentRoute: () => userRouteRoute,
} as any)
const usertenantBcWorkflowsIndexRoute =
  usertenantBcWorkflowsIndexRouteImport.update({
    id: "/workflows/",
    path: "/workflows/",
    getParentRoute: () => usertenantBcRouteRoute,
  } as any)
const usertenantBcPromptsIndexRoute =
  usertenantBcPromptsIndexRouteImport.update({
    id: "/prompts/",
    path: "/prompts/",
    getParentRoute: () => usertenantBcRouteRoute,
  } as any)
const usertenantBcEvaluationsIndexRoute =
  usertenantBcEvaluationsIndexRouteImport.update({
    id: "/evaluations/",
    path: "/evaluations/",
    getParentRoute: () => usertenantBcRouteRoute,
  } as any)
const usertenantBcDatasetsIndexRoute =
  usertenantBcDatasetsIndexRouteImport.update({
    id: "/datasets/",
    path: "/datasets/",
    getParentRoute: () => usertenantBcRouteRoute,
  } as any)
const publicAuthResetPasswordIndexRoute =
  publicAuthResetPasswordIndexRouteImport.update({
    id: "/reset-password/",
    path: "/reset-password/",
    getParentRoute: () => publicAuthRouteRoute,
  } as any)
const userTTenantSlugSubscriptionRoute =
  userTTenantSlugSubscriptionRouteImport.update({
    id: "/subscription",
    path: "/subscription",
    getParentRoute: () => userTTenantSlugRouteRoute,
  } as any)
const userTTenantSlugSettingsRoute = userTTenantSlugSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => userTTenantSlugRouteRoute,
} as any)
const userTTenantSlugPurchaseRoute = userTTenantSlugPurchaseRouteImport.update({
  id: "/purchase",
  path: "/purchase",
  getParentRoute: () => userTTenantSlugRouteRoute,
} as any)
const userTTenantSlugDashboardRoute =
  userTTenantSlugDashboardRouteImport.update({
    id: "/dashboard",
    path: "/dashboard",
    getParentRoute: () => userTTenantSlugRouteRoute,
  } as any)
const userTTenantSlugCheckoutRoute = userTTenantSlugCheckoutRouteImport.update({
  id: "/checkout",
  path: "/checkout",
  getParentRoute: () => userTTenantSlugRouteRoute,
} as any)
const usertenantBcWorkflowsIdRoute = usertenantBcWorkflowsIdRouteImport.update({
  id: "/workflows/$id",
  path: "/workflows/$id",
  getParentRoute: () => usertenantBcRouteRoute,
} as any)
const usertenantBcPromptsIdRoute = usertenantBcPromptsIdRouteImport.update({
  id: "/prompts/$id",
  path: "/prompts/$id",
  getParentRoute: () => usertenantBcRouteRoute,
} as any)
const usertenantBcEvaluationsIdRoute =
  usertenantBcEvaluationsIdRouteImport.update({
    id: "/evaluations/$id",
    path: "/evaluations/$id",
    getParentRoute: () => usertenantBcRouteRoute,
  } as any)
const usertenantBcDatasetsIdRoute = usertenantBcDatasetsIdRouteImport.update({
  id: "/datasets/$id",
  path: "/datasets/$id",
  getParentRoute: () => usertenantBcRouteRoute,
} as any)
const publicAuthVerifyRequestRoute = publicAuthVerifyRequestRouteImport.update({
  id: "/verify/request",
  path: "/verify/request",
  getParentRoute: () => publicAuthRouteRoute,
} as any)
const publicAuthVerifyApplyRoute = publicAuthVerifyApplyRouteImport.update({
  id: "/verify/apply",
  path: "/verify/apply",
  getParentRoute: () => publicAuthRouteRoute,
} as any)
const publicAuthResetPasswordTokenRoute =
  publicAuthResetPasswordTokenRouteImport.update({
    id: "/reset-password/$token",
    path: "/reset-password/$token",
    getParentRoute: () => publicAuthRouteRoute,
  } as any)
const userTTenantSlugWorkflowsIdRoute =
  userTTenantSlugWorkflowsIdRouteImport.update({
    id: "/workflows/$id",
    path: "/workflows/$id",
    getParentRoute: () => userTTenantSlugRouteRoute,
  } as any)
const userTTenantSlugPromptsIdRoute =
  userTTenantSlugPromptsIdRouteImport.update({
    id: "/prompts/$id",
    path: "/prompts/$id",
    getParentRoute: () => userTTenantSlugRouteRoute,
  } as any)
const userTTenantSlugEvaluationsIdRoute =
  userTTenantSlugEvaluationsIdRouteImport.update({
    id: "/evaluations/$id",
    path: "/evaluations/$id",
    getParentRoute: () => userTTenantSlugRouteRoute,
  } as any)
const userTTenantSlugDatasetsIdRoute =
  userTTenantSlugDatasetsIdRouteImport.update({
    id: "/datasets/$id",
    path: "/datasets/$id",
    getParentRoute: () => userTTenantSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/admin": typeof AdminRoute
  "/auth": typeof publicAuthRouteRouteWithChildren
  "/pricing": typeof publicPricingRoute
  "/account": typeof userAccountRoute
  "/onboarding": typeof userOnboardingRoute
  "/tmp": typeof userTmpRoute
  "/": typeof publicIndexRoute
  "/t/$tenantSlug": typeof userTTenantSlugRouteRouteWithChildren
  "/auth/login": typeof publicAuthLoginRoute
  "/auth/oauth-result": typeof publicAuthOauthResultRoute
  "/content/$slug": typeof publicContentSlugRoute
  "/legal/$slug": typeof publicLegalSlugRoute
  "/dashboard": typeof usertenantBcDashboardRoute
  "/purchase": typeof usertenantBcPurchaseRoute
  "/settings": typeof usertenantBcSettingsRoute
  "/auth/": typeof publicAuthIndexRoute
  "/auth/reset-password/$token": typeof publicAuthResetPasswordTokenRoute
  "/auth/verify/apply": typeof publicAuthVerifyApplyRoute
  "/auth/verify/request": typeof publicAuthVerifyRequestRoute
  "/datasets/$id": typeof usertenantBcDatasetsIdRoute
  "/evaluations/$id": typeof usertenantBcEvaluationsIdRoute
  "/prompts/$id": typeof usertenantBcPromptsIdRoute
  "/workflows/$id": typeof usertenantBcWorkflowsIdRoute
  "/t/$tenantSlug/checkout": typeof userTTenantSlugCheckoutRoute
  "/t/$tenantSlug/dashboard": typeof userTTenantSlugDashboardRoute
  "/t/$tenantSlug/purchase": typeof userTTenantSlugPurchaseRoute
  "/t/$tenantSlug/settings": typeof userTTenantSlugSettingsRoute
  "/t/$tenantSlug/subscription": typeof userTTenantSlugSubscriptionRoute
  "/auth/reset-password/": typeof publicAuthResetPasswordIndexRoute
  "/datasets/": typeof usertenantBcDatasetsIndexRoute
  "/evaluations/": typeof usertenantBcEvaluationsIndexRoute
  "/prompts/": typeof usertenantBcPromptsIndexRoute
  "/workflows/": typeof usertenantBcWorkflowsIndexRoute
  "/t/$tenantSlug/datasets/$id": typeof userTTenantSlugDatasetsIdRoute
  "/t/$tenantSlug/evaluations/$id": typeof userTTenantSlugEvaluationsIdRoute
  "/t/$tenantSlug/prompts/$id": typeof userTTenantSlugPromptsIdRoute
  "/t/$tenantSlug/workflows/$id": typeof userTTenantSlugWorkflowsIdRoute
}
export interface FileRoutesByTo {
  "/admin": typeof AdminRoute
  "/pricing": typeof publicPricingRoute
  "/account": typeof userAccountRoute
  "/onboarding": typeof userOnboardingRoute
  "/tmp": typeof userTmpRoute
  "/": typeof publicIndexRoute
  "/t/$tenantSlug": typeof userTTenantSlugRouteRouteWithChildren
  "/auth/login": typeof publicAuthLoginRoute
  "/auth/oauth-result": typeof publicAuthOauthResultRoute
  "/content/$slug": typeof publicContentSlugRoute
  "/legal/$slug": typeof publicLegalSlugRoute
  "/dashboard": typeof usertenantBcDashboardRoute
  "/purchase": typeof usertenantBcPurchaseRoute
  "/settings": typeof usertenantBcSettingsRoute
  "/auth": typeof publicAuthIndexRoute
  "/auth/reset-password/$token": typeof publicAuthResetPasswordTokenRoute
  "/auth/verify/apply": typeof publicAuthVerifyApplyRoute
  "/auth/verify/request": typeof publicAuthVerifyRequestRoute
  "/datasets/$id": typeof usertenantBcDatasetsIdRoute
  "/evaluations/$id": typeof usertenantBcEvaluationsIdRoute
  "/prompts/$id": typeof usertenantBcPromptsIdRoute
  "/workflows/$id": typeof usertenantBcWorkflowsIdRoute
  "/t/$tenantSlug/checkout": typeof userTTenantSlugCheckoutRoute
  "/t/$tenantSlug/dashboard": typeof userTTenantSlugDashboardRoute
  "/t/$tenantSlug/purchase": typeof userTTenantSlugPurchaseRoute
  "/t/$tenantSlug/settings": typeof userTTenantSlugSettingsRoute
  "/t/$tenantSlug/subscription": typeof userTTenantSlugSubscriptionRoute
  "/auth/reset-password": typeof publicAuthResetPasswordIndexRoute
  "/datasets": typeof usertenantBcDatasetsIndexRoute
  "/evaluations": typeof usertenantBcEvaluationsIndexRoute
  "/prompts": typeof usertenantBcPromptsIndexRoute
  "/workflows": typeof usertenantBcWorkflowsIndexRoute
  "/t/$tenantSlug/datasets/$id": typeof userTTenantSlugDatasetsIdRoute
  "/t/$tenantSlug/evaluations/$id": typeof userTTenantSlugEvaluationsIdRoute
  "/t/$tenantSlug/prompts/$id": typeof userTTenantSlugPromptsIdRoute
  "/t/$tenantSlug/workflows/$id": typeof userTTenantSlugWorkflowsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/(public)": typeof publicRouteRouteWithChildren
  "/(user)": typeof userRouteRouteWithChildren
  "/admin": typeof AdminRoute
  "/(public)/auth": typeof publicAuthRouteRouteWithChildren
  "/(user)/(tenantBc)": typeof usertenantBcRouteRouteWithChildren
  "/(public)/pricing": typeof publicPricingRoute
  "/(user)/account": typeof userAccountRoute
  "/(user)/onboarding": typeof userOnboardingRoute
  "/(user)/tmp": typeof userTmpRoute
  "/(public)/": typeof publicIndexRoute
  "/(user)/t/$tenantSlug": typeof userTTenantSlugRouteRouteWithChildren
  "/(public)/auth/login": typeof publicAuthLoginRoute
  "/(public)/auth/oauth-result": typeof publicAuthOauthResultRoute
  "/(public)/content/$slug": typeof publicContentSlugRoute
  "/(public)/legal/$slug": typeof publicLegalSlugRoute
  "/(user)/(tenantBc)/dashboard": typeof usertenantBcDashboardRoute
  "/(user)/(tenantBc)/purchase": typeof usertenantBcPurchaseRoute
  "/(user)/(tenantBc)/settings": typeof usertenantBcSettingsRoute
  "/(public)/auth/": typeof publicAuthIndexRoute
  "/(public)/auth/reset-password/$token": typeof publicAuthResetPasswordTokenRoute
  "/(public)/auth/verify/apply": typeof publicAuthVerifyApplyRoute
  "/(public)/auth/verify/request": typeof publicAuthVerifyRequestRoute
  "/(user)/(tenantBc)/datasets/$id": typeof usertenantBcDatasetsIdRoute
  "/(user)/(tenantBc)/evaluations/$id": typeof usertenantBcEvaluationsIdRoute
  "/(user)/(tenantBc)/prompts/$id": typeof usertenantBcPromptsIdRoute
  "/(user)/(tenantBc)/workflows/$id": typeof usertenantBcWorkflowsIdRoute
  "/(user)/t/$tenantSlug/checkout": typeof userTTenantSlugCheckoutRoute
  "/(user)/t/$tenantSlug/dashboard": typeof userTTenantSlugDashboardRoute
  "/(user)/t/$tenantSlug/purchase": typeof userTTenantSlugPurchaseRoute
  "/(user)/t/$tenantSlug/settings": typeof userTTenantSlugSettingsRoute
  "/(user)/t/$tenantSlug/subscription": typeof userTTenantSlugSubscriptionRoute
  "/(public)/auth/reset-password/": typeof publicAuthResetPasswordIndexRoute
  "/(user)/(tenantBc)/datasets/": typeof usertenantBcDatasetsIndexRoute
  "/(user)/(tenantBc)/evaluations/": typeof usertenantBcEvaluationsIndexRoute
  "/(user)/(tenantBc)/prompts/": typeof usertenantBcPromptsIndexRoute
  "/(user)/(tenantBc)/workflows/": typeof usertenantBcWorkflowsIndexRoute
  "/(user)/t/$tenantSlug/datasets/$id": typeof userTTenantSlugDatasetsIdRoute
  "/(user)/t/$tenantSlug/evaluations/$id": typeof userTTenantSlugEvaluationsIdRoute
  "/(user)/t/$tenantSlug/prompts/$id": typeof userTTenantSlugPromptsIdRoute
  "/(user)/t/$tenantSlug/workflows/$id": typeof userTTenantSlugWorkflowsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/admin"
    | "/auth"
    | "/pricing"
    | "/account"
    | "/onboarding"
    | "/tmp"
    | "/"
    | "/t/$tenantSlug"
    | "/auth/login"
    | "/auth/oauth-result"
    | "/content/$slug"
    | "/legal/$slug"
    | "/dashboard"
    | "/purchase"
    | "/settings"
    | "/auth/"
    | "/auth/reset-password/$token"
    | "/auth/verify/apply"
    | "/auth/verify/request"
    | "/datasets/$id"
    | "/evaluations/$id"
    | "/prompts/$id"
    | "/workflows/$id"
    | "/t/$tenantSlug/checkout"
    | "/t/$tenantSlug/dashboard"
    | "/t/$tenantSlug/purchase"
    | "/t/$tenantSlug/settings"
    | "/t/$tenantSlug/subscription"
    | "/auth/reset-password/"
    | "/datasets/"
    | "/evaluations/"
    | "/prompts/"
    | "/workflows/"
    | "/t/$tenantSlug/datasets/$id"
    | "/t/$tenantSlug/evaluations/$id"
    | "/t/$tenantSlug/prompts/$id"
    | "/t/$tenantSlug/workflows/$id"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/admin"
    | "/pricing"
    | "/account"
    | "/onboarding"
    | "/tmp"
    | "/"
    | "/t/$tenantSlug"
    | "/auth/login"
    | "/auth/oauth-result"
    | "/content/$slug"
    | "/legal/$slug"
    | "/dashboard"
    | "/purchase"
    | "/settings"
    | "/auth"
    | "/auth/reset-password/$token"
    | "/auth/verify/apply"
    | "/auth/verify/request"
    | "/datasets/$id"
    | "/evaluations/$id"
    | "/prompts/$id"
    | "/workflows/$id"
    | "/t/$tenantSlug/checkout"
    | "/t/$tenantSlug/dashboard"
    | "/t/$tenantSlug/purchase"
    | "/t/$tenantSlug/settings"
    | "/t/$tenantSlug/subscription"
    | "/auth/reset-password"
    | "/datasets"
    | "/evaluations"
    | "/prompts"
    | "/workflows"
    | "/t/$tenantSlug/datasets/$id"
    | "/t/$tenantSlug/evaluations/$id"
    | "/t/$tenantSlug/prompts/$id"
    | "/t/$tenantSlug/workflows/$id"
  id:
    | "__root__"
    | "/(public)"
    | "/(user)"
    | "/admin"
    | "/(public)/auth"
    | "/(user)/(tenantBc)"
    | "/(public)/pricing"
    | "/(user)/account"
    | "/(user)/onboarding"
    | "/(user)/tmp"
    | "/(public)/"
    | "/(user)/t/$tenantSlug"
    | "/(public)/auth/login"
    | "/(public)/auth/oauth-result"
    | "/(public)/content/$slug"
    | "/(public)/legal/$slug"
    | "/(user)/(tenantBc)/dashboard"
    | "/(user)/(tenantBc)/purchase"
    | "/(user)/(tenantBc)/settings"
    | "/(public)/auth/"
    | "/(public)/auth/reset-password/$token"
    | "/(public)/auth/verify/apply"
    | "/(public)/auth/verify/request"
    | "/(user)/(tenantBc)/datasets/$id"
    | "/(user)/(tenantBc)/evaluations/$id"
    | "/(user)/(tenantBc)/prompts/$id"
    | "/(user)/(tenantBc)/workflows/$id"
    | "/(user)/t/$tenantSlug/checkout"
    | "/(user)/t/$tenantSlug/dashboard"
    | "/(user)/t/$tenantSlug/purchase"
    | "/(user)/t/$tenantSlug/settings"
    | "/(user)/t/$tenantSlug/subscription"
    | "/(public)/auth/reset-password/"
    | "/(user)/(tenantBc)/datasets/"
    | "/(user)/(tenantBc)/evaluations/"
    | "/(user)/(tenantBc)/prompts/"
    | "/(user)/(tenantBc)/workflows/"
    | "/(user)/t/$tenantSlug/datasets/$id"
    | "/(user)/t/$tenantSlug/evaluations/$id"
    | "/(user)/t/$tenantSlug/prompts/$id"
    | "/(user)/t/$tenantSlug/workflows/$id"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  publicRouteRoute: typeof publicRouteRouteWithChildren
  userRouteRoute: typeof userRouteRouteWithChildren
  AdminRoute: typeof AdminRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(user)": {
      id: "/(user)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof userRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(public)": {
      id: "/(public)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(public)/": {
      id: "/(public)/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof publicRouteRoute
    }
    "/(user)/tmp": {
      id: "/(user)/tmp"
      path: "/tmp"
      fullPath: "/tmp"
      preLoaderRoute: typeof userTmpRouteImport
      parentRoute: typeof userRouteRoute
    }
    "/(user)/onboarding": {
      id: "/(user)/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof userOnboardingRouteImport
      parentRoute: typeof userRouteRoute
    }
    "/(user)/account": {
      id: "/(user)/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof userAccountRouteImport
      parentRoute: typeof userRouteRoute
    }
    "/(public)/pricing": {
      id: "/(public)/pricing"
      path: "/pricing"
      fullPath: "/pricing"
      preLoaderRoute: typeof publicPricingRouteImport
      parentRoute: typeof publicRouteRoute
    }
    "/(user)/(tenantBc)": {
      id: "/(user)/(tenantBc)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof usertenantBcRouteRouteImport
      parentRoute: typeof userRouteRoute
    }
    "/(public)/auth": {
      id: "/(public)/auth"
      path: "/auth"
      fullPath: "/auth"
      preLoaderRoute: typeof publicAuthRouteRouteImport
      parentRoute: typeof publicRouteRoute
    }
    "/(public)/auth/": {
      id: "/(public)/auth/"
      path: "/"
      fullPath: "/auth/"
      preLoaderRoute: typeof publicAuthIndexRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(user)/(tenantBc)/settings": {
      id: "/(user)/(tenantBc)/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof usertenantBcSettingsRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/purchase": {
      id: "/(user)/(tenantBc)/purchase"
      path: "/purchase"
      fullPath: "/purchase"
      preLoaderRoute: typeof usertenantBcPurchaseRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/dashboard": {
      id: "/(user)/(tenantBc)/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof usertenantBcDashboardRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(public)/legal/$slug": {
      id: "/(public)/legal/$slug"
      path: "/legal/$slug"
      fullPath: "/legal/$slug"
      preLoaderRoute: typeof publicLegalSlugRouteImport
      parentRoute: typeof publicRouteRoute
    }
    "/(public)/content/$slug": {
      id: "/(public)/content/$slug"
      path: "/content/$slug"
      fullPath: "/content/$slug"
      preLoaderRoute: typeof publicContentSlugRouteImport
      parentRoute: typeof publicRouteRoute
    }
    "/(public)/auth/oauth-result": {
      id: "/(public)/auth/oauth-result"
      path: "/oauth-result"
      fullPath: "/auth/oauth-result"
      preLoaderRoute: typeof publicAuthOauthResultRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(public)/auth/login": {
      id: "/(public)/auth/login"
      path: "/login"
      fullPath: "/auth/login"
      preLoaderRoute: typeof publicAuthLoginRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(user)/t/$tenantSlug": {
      id: "/(user)/t/$tenantSlug"
      path: "/t/$tenantSlug"
      fullPath: "/t/$tenantSlug"
      preLoaderRoute: typeof userTTenantSlugRouteRouteImport
      parentRoute: typeof userRouteRoute
    }
    "/(user)/(tenantBc)/workflows/": {
      id: "/(user)/(tenantBc)/workflows/"
      path: "/workflows"
      fullPath: "/workflows/"
      preLoaderRoute: typeof usertenantBcWorkflowsIndexRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/prompts/": {
      id: "/(user)/(tenantBc)/prompts/"
      path: "/prompts"
      fullPath: "/prompts/"
      preLoaderRoute: typeof usertenantBcPromptsIndexRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/evaluations/": {
      id: "/(user)/(tenantBc)/evaluations/"
      path: "/evaluations"
      fullPath: "/evaluations/"
      preLoaderRoute: typeof usertenantBcEvaluationsIndexRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/datasets/": {
      id: "/(user)/(tenantBc)/datasets/"
      path: "/datasets"
      fullPath: "/datasets/"
      preLoaderRoute: typeof usertenantBcDatasetsIndexRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(public)/auth/reset-password/": {
      id: "/(public)/auth/reset-password/"
      path: "/reset-password"
      fullPath: "/auth/reset-password/"
      preLoaderRoute: typeof publicAuthResetPasswordIndexRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(user)/t/$tenantSlug/subscription": {
      id: "/(user)/t/$tenantSlug/subscription"
      path: "/subscription"
      fullPath: "/t/$tenantSlug/subscription"
      preLoaderRoute: typeof userTTenantSlugSubscriptionRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/settings": {
      id: "/(user)/t/$tenantSlug/settings"
      path: "/settings"
      fullPath: "/t/$tenantSlug/settings"
      preLoaderRoute: typeof userTTenantSlugSettingsRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/purchase": {
      id: "/(user)/t/$tenantSlug/purchase"
      path: "/purchase"
      fullPath: "/t/$tenantSlug/purchase"
      preLoaderRoute: typeof userTTenantSlugPurchaseRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/dashboard": {
      id: "/(user)/t/$tenantSlug/dashboard"
      path: "/dashboard"
      fullPath: "/t/$tenantSlug/dashboard"
      preLoaderRoute: typeof userTTenantSlugDashboardRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/checkout": {
      id: "/(user)/t/$tenantSlug/checkout"
      path: "/checkout"
      fullPath: "/t/$tenantSlug/checkout"
      preLoaderRoute: typeof userTTenantSlugCheckoutRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/(tenantBc)/workflows/$id": {
      id: "/(user)/(tenantBc)/workflows/$id"
      path: "/workflows/$id"
      fullPath: "/workflows/$id"
      preLoaderRoute: typeof usertenantBcWorkflowsIdRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/prompts/$id": {
      id: "/(user)/(tenantBc)/prompts/$id"
      path: "/prompts/$id"
      fullPath: "/prompts/$id"
      preLoaderRoute: typeof usertenantBcPromptsIdRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/evaluations/$id": {
      id: "/(user)/(tenantBc)/evaluations/$id"
      path: "/evaluations/$id"
      fullPath: "/evaluations/$id"
      preLoaderRoute: typeof usertenantBcEvaluationsIdRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(user)/(tenantBc)/datasets/$id": {
      id: "/(user)/(tenantBc)/datasets/$id"
      path: "/datasets/$id"
      fullPath: "/datasets/$id"
      preLoaderRoute: typeof usertenantBcDatasetsIdRouteImport
      parentRoute: typeof usertenantBcRouteRoute
    }
    "/(public)/auth/verify/request": {
      id: "/(public)/auth/verify/request"
      path: "/verify/request"
      fullPath: "/auth/verify/request"
      preLoaderRoute: typeof publicAuthVerifyRequestRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(public)/auth/verify/apply": {
      id: "/(public)/auth/verify/apply"
      path: "/verify/apply"
      fullPath: "/auth/verify/apply"
      preLoaderRoute: typeof publicAuthVerifyApplyRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(public)/auth/reset-password/$token": {
      id: "/(public)/auth/reset-password/$token"
      path: "/reset-password/$token"
      fullPath: "/auth/reset-password/$token"
      preLoaderRoute: typeof publicAuthResetPasswordTokenRouteImport
      parentRoute: typeof publicAuthRouteRoute
    }
    "/(user)/t/$tenantSlug/workflows/$id": {
      id: "/(user)/t/$tenantSlug/workflows/$id"
      path: "/workflows/$id"
      fullPath: "/t/$tenantSlug/workflows/$id"
      preLoaderRoute: typeof userTTenantSlugWorkflowsIdRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/prompts/$id": {
      id: "/(user)/t/$tenantSlug/prompts/$id"
      path: "/prompts/$id"
      fullPath: "/t/$tenantSlug/prompts/$id"
      preLoaderRoute: typeof userTTenantSlugPromptsIdRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/evaluations/$id": {
      id: "/(user)/t/$tenantSlug/evaluations/$id"
      path: "/evaluations/$id"
      fullPath: "/t/$tenantSlug/evaluations/$id"
      preLoaderRoute: typeof userTTenantSlugEvaluationsIdRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
    "/(user)/t/$tenantSlug/datasets/$id": {
      id: "/(user)/t/$tenantSlug/datasets/$id"
      path: "/datasets/$id"
      fullPath: "/t/$tenantSlug/datasets/$id"
      preLoaderRoute: typeof userTTenantSlugDatasetsIdRouteImport
      parentRoute: typeof userTTenantSlugRouteRoute
    }
  }
}

interface publicAuthRouteRouteChildren {
  publicAuthLoginRoute: typeof publicAuthLoginRoute
  publicAuthOauthResultRoute: typeof publicAuthOauthResultRoute
  publicAuthIndexRoute: typeof publicAuthIndexRoute
  publicAuthResetPasswordTokenRoute: typeof publicAuthResetPasswordTokenRoute
  publicAuthVerifyApplyRoute: typeof publicAuthVerifyApplyRoute
  publicAuthVerifyRequestRoute: typeof publicAuthVerifyRequestRoute
  publicAuthResetPasswordIndexRoute: typeof publicAuthResetPasswordIndexRoute
}

const publicAuthRouteRouteChildren: publicAuthRouteRouteChildren = {
  publicAuthLoginRoute: publicAuthLoginRoute,
  publicAuthOauthResultRoute: publicAuthOauthResultRoute,
  publicAuthIndexRoute: publicAuthIndexRoute,
  publicAuthResetPasswordTokenRoute: publicAuthResetPasswordTokenRoute,
  publicAuthVerifyApplyRoute: publicAuthVerifyApplyRoute,
  publicAuthVerifyRequestRoute: publicAuthVerifyRequestRoute,
  publicAuthResetPasswordIndexRoute: publicAuthResetPasswordIndexRoute,
}

const publicAuthRouteRouteWithChildren = publicAuthRouteRoute._addFileChildren(
  publicAuthRouteRouteChildren,
)

interface publicRouteRouteChildren {
  publicAuthRouteRoute: typeof publicAuthRouteRouteWithChildren
  publicPricingRoute: typeof publicPricingRoute
  publicIndexRoute: typeof publicIndexRoute
  publicContentSlugRoute: typeof publicContentSlugRoute
  publicLegalSlugRoute: typeof publicLegalSlugRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicAuthRouteRoute: publicAuthRouteRouteWithChildren,
  publicPricingRoute: publicPricingRoute,
  publicIndexRoute: publicIndexRoute,
  publicContentSlugRoute: publicContentSlugRoute,
  publicLegalSlugRoute: publicLegalSlugRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

interface usertenantBcRouteRouteChildren {
  usertenantBcDashboardRoute: typeof usertenantBcDashboardRoute
  usertenantBcPurchaseRoute: typeof usertenantBcPurchaseRoute
  usertenantBcSettingsRoute: typeof usertenantBcSettingsRoute
  usertenantBcDatasetsIdRoute: typeof usertenantBcDatasetsIdRoute
  usertenantBcEvaluationsIdRoute: typeof usertenantBcEvaluationsIdRoute
  usertenantBcPromptsIdRoute: typeof usertenantBcPromptsIdRoute
  usertenantBcWorkflowsIdRoute: typeof usertenantBcWorkflowsIdRoute
  usertenantBcDatasetsIndexRoute: typeof usertenantBcDatasetsIndexRoute
  usertenantBcEvaluationsIndexRoute: typeof usertenantBcEvaluationsIndexRoute
  usertenantBcPromptsIndexRoute: typeof usertenantBcPromptsIndexRoute
  usertenantBcWorkflowsIndexRoute: typeof usertenantBcWorkflowsIndexRoute
}

const usertenantBcRouteRouteChildren: usertenantBcRouteRouteChildren = {
  usertenantBcDashboardRoute: usertenantBcDashboardRoute,
  usertenantBcPurchaseRoute: usertenantBcPurchaseRoute,
  usertenantBcSettingsRoute: usertenantBcSettingsRoute,
  usertenantBcDatasetsIdRoute: usertenantBcDatasetsIdRoute,
  usertenantBcEvaluationsIdRoute: usertenantBcEvaluationsIdRoute,
  usertenantBcPromptsIdRoute: usertenantBcPromptsIdRoute,
  usertenantBcWorkflowsIdRoute: usertenantBcWorkflowsIdRoute,
  usertenantBcDatasetsIndexRoute: usertenantBcDatasetsIndexRoute,
  usertenantBcEvaluationsIndexRoute: usertenantBcEvaluationsIndexRoute,
  usertenantBcPromptsIndexRoute: usertenantBcPromptsIndexRoute,
  usertenantBcWorkflowsIndexRoute: usertenantBcWorkflowsIndexRoute,
}

const usertenantBcRouteRouteWithChildren =
  usertenantBcRouteRoute._addFileChildren(usertenantBcRouteRouteChildren)

interface userTTenantSlugRouteRouteChildren {
  userTTenantSlugCheckoutRoute: typeof userTTenantSlugCheckoutRoute
  userTTenantSlugDashboardRoute: typeof userTTenantSlugDashboardRoute
  userTTenantSlugPurchaseRoute: typeof userTTenantSlugPurchaseRoute
  userTTenantSlugSettingsRoute: typeof userTTenantSlugSettingsRoute
  userTTenantSlugSubscriptionRoute: typeof userTTenantSlugSubscriptionRoute
  userTTenantSlugDatasetsIdRoute: typeof userTTenantSlugDatasetsIdRoute
  userTTenantSlugEvaluationsIdRoute: typeof userTTenantSlugEvaluationsIdRoute
  userTTenantSlugPromptsIdRoute: typeof userTTenantSlugPromptsIdRoute
  userTTenantSlugWorkflowsIdRoute: typeof userTTenantSlugWorkflowsIdRoute
}

const userTTenantSlugRouteRouteChildren: userTTenantSlugRouteRouteChildren = {
  userTTenantSlugCheckoutRoute: userTTenantSlugCheckoutRoute,
  userTTenantSlugDashboardRoute: userTTenantSlugDashboardRoute,
  userTTenantSlugPurchaseRoute: userTTenantSlugPurchaseRoute,
  userTTenantSlugSettingsRoute: userTTenantSlugSettingsRoute,
  userTTenantSlugSubscriptionRoute: userTTenantSlugSubscriptionRoute,
  userTTenantSlugDatasetsIdRoute: userTTenantSlugDatasetsIdRoute,
  userTTenantSlugEvaluationsIdRoute: userTTenantSlugEvaluationsIdRoute,
  userTTenantSlugPromptsIdRoute: userTTenantSlugPromptsIdRoute,
  userTTenantSlugWorkflowsIdRoute: userTTenantSlugWorkflowsIdRoute,
}

const userTTenantSlugRouteRouteWithChildren =
  userTTenantSlugRouteRoute._addFileChildren(userTTenantSlugRouteRouteChildren)

interface userRouteRouteChildren {
  usertenantBcRouteRoute: typeof usertenantBcRouteRouteWithChildren
  userAccountRoute: typeof userAccountRoute
  userOnboardingRoute: typeof userOnboardingRoute
  userTmpRoute: typeof userTmpRoute
  userTTenantSlugRouteRoute: typeof userTTenantSlugRouteRouteWithChildren
}

const userRouteRouteChildren: userRouteRouteChildren = {
  usertenantBcRouteRoute: usertenantBcRouteRouteWithChildren,
  userAccountRoute: userAccountRoute,
  userOnboardingRoute: userOnboardingRoute,
  userTmpRoute: userTmpRoute,
  userTTenantSlugRouteRoute: userTTenantSlugRouteRouteWithChildren,
}

const userRouteRouteWithChildren = userRouteRoute._addFileChildren(
  userRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,
  userRouteRoute: userRouteRouteWithChildren,
  AdminRoute: AdminRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
